(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotional-banner"] && !Shopify.designMode) return;
  try {
    
  function initPromotionalBanners() {
    const banners = document.querySelectorAll('.promotional-banner-wrapper');
    banners.forEach((banner) => {
      const sectionId = banner.dataset.sectionId;
      const storageKey = `khwab_promo_dismissed_${sectionId}`;

      if (banner.dataset.dismissible === 'true' && sessionStorage.getItem(storageKey)) {
        banner.setAttribute('data-hidden', 'true');
        return;
      }

      const dismissBtn = banner.querySelector('[data-dismiss-banner]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', () => {
          banner.setAttribute('data-hidden', 'true');
          sessionStorage.setItem(storageKey, 'true');
        });
      }

      const copyBtn = banner.querySelector('.promotional-banner__code-pill');
      if (copyBtn) {
        copyBtn.addEventListener('click', async () => {
          const code = copyBtn.dataset.promoCode;
          const statusText = copyBtn.querySelector('.promotional-banner__code-status');
          if (!code) return;

          try {
            await navigator.clipboard.writeText(code);
            copyBtn.classList.add('is-copied');
            if (statusText) statusText.textContent = 'Copied!';
            setTimeout(() => {
              copyBtn.classList.remove('is-copied');
              if (statusText) statusText.textContent = 'Copy';
            }, 2500);
          } catch (e) {
            console.error('Failed to copy promotional code', e);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromotionalBanners);
  } else {
    initPromotionalBanners();
  }

  document.addEventListener('shopify:section:load', initPromotionalBanners);

  } catch(e) { console.error(e); }
})();
})();
